// QR funnel session (§12): one scan → landing → (quick register) → experience.
// Persisted so the scan survives the auth redirect; scoped to one branch and short-lived.

const KEY    = "samt:qr";
const TTL_MS = 12 * 60 * 60 * 1000;

export function saveQrSession(session) {
  try { localStorage.setItem(KEY, JSON.stringify({ ...session, at: Date.now() })); } catch { /* storage blocked */ }
}

export function getQrSession() {
  try {
    const s = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!s || !s.scan_id || !s.code) return null;
    if (Date.now() - (s.at || 0) > TTL_MS) { clearQrSession(); return null; }
    return s;
  } catch { return null; }
}

export function updateQrSession(patch) {
  const s = getQrSession();
  if (s) saveQrSession({ ...s, ...patch });
}

export function clearQrSession() {
  try { localStorage.removeItem(KEY); } catch { /* storage blocked */ }
}

// The experience page must never attach a scan from a different place.
export function qrSessionForBranch(branchId) {
  const s = getQrSession();
  return s && String(s.branch_id) === String(branchId) ? s : null;
}
